import { useContext, useEffect } from "react";
import { AuthContext } from "../Context/Auth";
import { useState } from "react";
import Login from "./Login/Login";
import Signup from "./Signup/Signup";
import ForgetPassword from './ResetPassword';
import ResetPassword from "./ResetPassword";

const AuthModal = ({ loginHeader, signupHeader, closeModal, resetPasswordHeader = "" }) => {
  const [shouldRegister, setShouldRegister] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);

  const { authState } = useContext(AuthContext);

  useEffect(() => {
    if (authState?.isAuthenticated) {
      closeModal();
    }
  }, [authState.isAuthenticated, closeModal]);

  const userShouldRegister = () => {
    setResetPassword(false);
    setShouldRegister(true)
  };
  const userShouldLogin = () => {
    setResetPassword(false);
    setShouldRegister(false)};
  const shouldResetPassword = () => setResetPassword(true);

  return (
    <div className="  px-5 text-boudoir w-full md:w-auto">
      <div className="py-7 px-8 bg-white shadow-sub2 md:w-523 mx-auto md:p-20">
        {!resetPassword && shouldRegister && signupHeader}
        {!resetPassword && !shouldRegister && loginHeader}
        {resetPassword && resetPasswordHeader }
        <div>
          {!resetPassword && !shouldRegister && <Login shouldResetPassword={shouldResetPassword} shouldRegister={userShouldRegister} />}
          {!resetPassword && shouldRegister && <Signup shouldLogin={userShouldLogin} />}
          {resetPassword && <ResetPassword shouldLogin={userShouldLogin} />}
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
